import request from '../http';

export const listDepts = (params) =>
  request({ url: '/system/depts', method: 'get', params });

export const getDeptTree = (params, config) =>
  request({ url: '/system/depts/tree', method: 'get', params, ...config });

export const createDept = (data) =>
  request({ url: '/system/depts', method: 'post', data });

export const updateDept = (id, data) =>
  request({ url: `/system/depts/${id}`, method: 'put', data });

export const deleteDept = (id) =>
  request({ url: `/system/depts/${id}`, method: 'delete' });

/** 全部部门↔投放部门映射（仅超级管理员 userId=1） */
export const listDeptAdsBindsAll = () =>
  request({ url: '/system/depts/ads-binds', method: 'get' });

/** 维护单个 B 部门与 A 部门主键映射（仅超级管理员） */
export const saveDeptAdsBind = (aiDeptId, data) =>
  request({ url: `/system/depts/${aiDeptId}/ads-bind`, method: 'put', data });
